<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Cli&euml;nt wijzigen</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeEditClientQueueDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <div class="hogans-alerts">
      <v-alert v-if="feedback" :value="true" type="warning">
        {{ feedback }}
      </v-alert>
    </div>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="AddClientQueueForm" v-model="valid" lazy-validation>
        <v-text-field
          label="Naam"
          v-model="selectedClientQueueItem.name"
          :rules="requiredRules"
          prepend-icon="account_box"
          required
        ></v-text-field>
        <v-text-field
          label="Telefooonnummer"
          v-model="selectedClientQueueItem.phone"
          :rules="requiredRules"
          prepend-icon="phone"
          required
        ></v-text-field>
        <v-text-field
          label="Behandeling"
          v-model="selectedClientQueueItem.treatment"
          required
          prepend-icon="event_seat"
        ></v-text-field>
        <v-select
          v-model="selectedClientQueueItem.treatmentTime"
          :items="treatmentTimes"
          label="Behandeltijd"
          prepend-icon="timer"
          required
        ></v-select>

        <v-menu
          ref="dateDialog"
          :close-on-content-click="false"
          v-model="queueEndDateDialog"
          transition="scale-transition"
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-on="on"
              :color="companyPrimaryColor"
              slot="activator"
              v-model="queueEndDateFormatted"
              label="Einddatum"
              hint="Tot wanneer wordt de klant weergegeven op de wachtlijst?"
              persistent-hint
              prepend-icon="today"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker
            :color="companyPrimaryColor"
            v-model="queueEndDatePicker"
            :min="today"
            :show-current="true"
            no-title
            @input="queueEndDateDialog = false"
          ></v-date-picker>
        </v-menu>

        <v-select
          v-if="branches.length > 1"
          v-model="selectedClientQueueItem.branch"
          :items="branches"
          label="Selecteer salon"
          item-text="branchName"
          item-value="id"
          prepend-icon="location_on"
          required
          :rules="requiredRules"
        ></v-select>
        <v-text-field
          label="Gewenste medewerker"
          v-model="selectedClientQueueItem.employee"
          required
          prepend-icon="face"
        ></v-text-field>
        <v-textarea
          label="Opmerkingen"
          v-model="selectedClientQueueItem.notes"
          required
          prepend-icon="feedback"
        ></v-textarea>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeEditClientQueueDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :dark="changed"
              rounded
              :depressed="!changed"
              :disabled="!changed"
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              :color="companySecondaryColor"
              @click="updateClientToQueue()"
            >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import platform from "platform";
import moment from "moment";

export default {
  name: "edit-client-queue-form",
  props: [
    "branches",
    "selectedClientQueueItem",
    "selectedClientQueueItemOriginal",
  ],
  data() {
    return {
      valid: false,
      queueEndDateDialog: false,
      queueEndDatePicker: null,
      requiredRules: [(v) => !!v || "Dit veld is verplicht"],
      treatmentTimes: [
        "20 min",
        "30 min",
        "40 min",
        "50 min",
        "1 uur",
        "1,5 uur",
        "> 1,5 uur",
        "Onbekend",
      ],
      today: null,
      emailRules: [
        (v) => !!v || "E-mail is verplicht",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      feedback: null,
    };
  },

  created() {
    // Datum van vandaag
    this.today = moment().format("YYYY-MM-DD");
  },

  watch: {
    selectedClientQueueItem: {
      handler: function() {
        if (this.queueEndDatePicker == null) {
          this.queueEndDatePicker = this.selectedClientQueueItem.queueEndDatePicker;
        }
      },
      deep: true,
    },
  },

  methods: {
    closeEditClientQueueDialog() {
      this.$emit("editQueueDialogChange", false);
      this.feedback = null;
    },

    updateClientToQueue() {
      if (this.$refs.AddClientQueueForm.validate()) {
        db.collection("clientQueue")
          .doc(this.selectedClientQueueItem.id)
          .update({
            // Basic Company Settings
            name: this.selectedClientQueueItem.name,
            salonhubId: this.selectedClientQueueItem.salonhubId,
            phone: this.selectedClientQueueItem.phone,
            branch: this.selectedClientQueueItem.branch,
            treatment: this.selectedClientQueueItem.treatment,
            treatmentTime: this.selectedClientQueueItem.treatmentTime,
            queueEndDate: new Date(this.queueEndDatePicker),
            employee: this.selectedClientQueueItem.employee,
            notes: this.selectedClientQueueItem.notes,
          })
          .then(() => {
            console.log("New date: ", new Date(this.queueEndDatePicker));
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + " " + platform.version,
              pillarrrVersion: this.$store.state.version,
              action:
                "Wachtrij item voor " +
                this.selectedClientQueueItem.name +
                " aangepast",
              extra:
                "<b>ORIGINELE GEGEVENS</b><br>" +
                "<b>Naam</b>: " +
                this.selectedClientQueueItemOriginal.name +
                "<br>" +
                "<b>Behandeling</b>: " +
                this.selectedClientQueueItemOriginal.treatment +
                "<br>" +
                "<b>Einddatum voor wachten</b>: " +
                this.selectedClientQueueItemOriginal.queueEndDate +
                "<br><br>" +
                "<b>ORIGINELE GEGEVENS</b><br>" +
                "<b>Naam</b>: " +
                this.selectedClientQueueItem.name +
                "<br>" +
                "<b>Behandeling</b>: " +
                this.selectedClientQueueItem.treatment +
                "<br>" +
                "<b>Einddatum voor wachten</b>: " +
                this.selectedClientQueueItem.queueEndDate,
            });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeEditClientQueueDialog();
            console.log("ClientQueue succesfully updated");
          })
          .catch((error) => {
            console.error("Error updating ClientQueue: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error updating ClientQueue: " + this.activeCompName,
              software: String(platform.os),
              browser: platform.name + " " + platform.version,
              pillarrrVersion: this.$store.state.version,
              extra: JSON.stringify(error),
            });
          });
      } else {
        this.feedback = "Vul alle velden in om wijzingen op te slaan.";
      }
    },

    formatDate(date) {
      // Datum omvormen naar Europese leesbare datum
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
  },
  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    queueEndDateFormatted() {
      // Datum omvormen naar Europese leesbare datum
      return this.formatDate(this.queueEndDatePicker);
    },
    changed() {
      if (
        _.isEqual(
          this.selectedClientQueueItem,
          this.selectedClientQueueItemOriginal,
        ) == false ||
        this.queueEndDatePicker !=
          this.selectedClientQueueItem.queueEndDatePicker
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
